<template>
  <div class="mt-2 mb-6">
    <div v-if="showAnimation">
        <v-row >
        <v-col cols="12">
            <v-card max-width="3000" max-height="400" color="primary darken-1">
            <div style="height: 400px;">
                <LoadingAnimation @loopComplete="loadAnimationComplete" />
            </div>
            </v-card>
        </v-col>
        </v-row>
    </div>
    <div v-else>
        <v-row class="align-center justify-center white--text hidden-sm-and-down">
            <v-col cols="12" sm="6" md="6" align-self="start" align="start" class="justify-start align-start">
                <strong class="subtitle-1 font-weight-bold white--text">Dados hidrológicos</strong>
            </v-col>
            <v-spacer />
            <v-col cols="12" sm="6" md="6" align-self="end" align="end" class="justify-end align-end">
                <strong class="subtitle-1 font-weight-bold white--text">Dados de precipitação na bacia de contribuição</strong>
            </v-col>
            </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6" class="hidden-md-and-up">
          <strong class="subtitle-1 font-weight-bold white--text">Dados hidrológicos</strong>
        </v-col>
      </v-row>
            <v-row>
            <v-col>
                <saic-precipitation-data
                  :accumulatedRainOfMonth="accumulatedRainOfMonth"
                  :avarageUsefulVolume="avarageUsefulVolume"
                  :avarageUsefulVolumePercentage="avarageUsefulVolumePercentage"
                  :currentMonthFormat="currentMonthFormat"
                  :currentYearFormat="currentYearFormat"
                >
                </saic-precipitation-data>
            </v-col>
        </v-row>
        <v-row justify="center" align="center">
          <v-col>
            <saic-hydrological-data
              :currentMonthFormat="currentMonthFormat"
              :currentYearFormat="currentYearFormat"
              :rainFromLastThirtydays="accumulatedOfLastThirtyDays"
              :avarageClimatologyLastThirtyYears="climatographicAverage"
            >
            </saic-hydrological-data>
          </v-col>
        </v-row>
      <v-row class="hidden-md-and-up">
        <!-- mobile and tablet -->
        <v-col cols="12" align-self="start" align="start" class="justify-start align-start">
          <strong class="subtitle-1 font-weight-bold white--text">Dados de precipitação na bacia de contribuição</strong>
        </v-col>
        <v-col cols="12" sm="12" md="6">
          <v-card class="primary darken-1">
            <v-row v-if="accumulatedRainOfMonth" class="ml-1">
              <v-col cols="12" class="ml-1">
                <v-icon style="color: lightgrey" left small>restore</v-icon>
                <span style="color: lightgrey; font-size: small">Atualizado em {{accumulatedRainOfMonth.updated}}</span>
              </v-col>
            </v-row>
            <v-card-title class="mt-n5">
              <v-icon color="secondary lighten-1" class="mb-2" size="24">
                mdi-weather-pouring
              </v-icon>
            </v-card-title>
            <v-card-subtitle class="font-weight-bold white--text">Chuva do mês atual</v-card-subtitle>
            <v-card-text>
              <v-row v-if="accumulatedRainOfMonth" class="white--text">
                <v-col class="pr-0" cols="6" style="max-width: 160px;">
                  <strong class="value-text">{{accumulatedRainOfMonth.value}}</strong>
                  <span class="ml-1 unit-measurement-text">mm</span>
                </v-col>
                <v-col class="pr-0" cols="6">
                  <span>Acumulado do mês de {{currentMonthFormat}}</span>
                </v-col>
              </v-row>
              <v-row v-else class="white--text">
                <v-col class="pa-3" cols="12">
                  <h2>Em breve</h2>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="mt-2" cols="6" sm="6" md="3">
          <v-card :class="accumulatedOfLastThirtyDays ? 'data-cards' : 'no-data-cards'" color="primary darken-1">
            <v-row v-if="accumulatedOfLastThirtyDays" class="ml-1">
              <v-col cols="12" class="ml-1">
                <v-icon style="color: lightgrey" left small>restore</v-icon>
                <span style="color: lightgrey; font-size: small">Atualizado em {{accumulatedOfLastThirtyDays.updated}}</span>
              </v-col>
            </v-row>
            <v-card-title class="mt-n5">
              <v-icon color="secondary lighten-1" class="mb-2" size="24">
                mdi-weather-pouring
              </v-icon>
            </v-card-title>
            <v-card-subtitle class="font-weight-bold white--text">Chuva dos últimos 30 dias</v-card-subtitle>
            <v-card-text>
              <v-row v-if="accumulatedOfLastThirtyDays" class="white--text">
                <v-col class="pr-0" cols="12">
                  <strong class="value-text">{{accumulatedOfLastThirtyDays.value}}</strong>
                  <span class="ml-1 unit-measurement-text">mm</span>
                </v-col>
                <v-col class="pt-0 pr-0" cols="12">
                  <span>Acumulado do últimos 30 dias</span>
                </v-col>
              </v-row>
              <v-row v-else class="white--text">
                <v-col class="pa-3" cols="12">
                  <h2>Em breve</h2>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="mt-2" cols="6" sm="6" md="3">
          <v-card :class="climatographicAverage ? 'data-cards' : 'no-data-cards'" color="primary darken-1">
            <v-row v-if="climatographicAverage" class="ml-1">
              <v-col cols="12" class="ml-1">
                <v-icon style="color: lightgrey" left small>restore</v-icon>
                <span style="color: lightgrey; font-size: small">Atualizado em {{climatographicAverage.updated}}</span>
              </v-col>
            </v-row>
            <v-card-title class="mt-n5">
              <v-icon color="secondary lighten-1" class="mb-2" size="24">
                mdi-weather-pouring
              </v-icon>
            </v-card-title>
            <v-card-subtitle class="font-weight-bold white--text">Média climatológica</v-card-subtitle>
            <v-card-text>
              <v-row v-if="climatographicAverage" class="white--text">
                <v-col class="pr-0" cols="12">
                  <strong class="value-text">{{climatographicAverage.value}}</strong>
                  <span class="ml-1 unit-measurement-text">mm</span>
                </v-col>
                <v-col class="pt-0 pr-0" cols="12">
                  <span>Média de 1979 - {{ currentYearFormat }} do mês de {{currentMonthFormat}}</span>
                </v-col>
              </v-row>
              <v-row v-else class="white--text">
                <v-col class="pa-3" cols="12">
                  <h2>Em breve</h2>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import LoadingAnimation from "../../common/LoadingAnimation";
import SaicPrecipitationData from './SaicPrecipitationData.vue';
import SaicHydrologicalData from './SaicHydrologicalData.vue';
export default {
  name: "SaicCurrentSituationOfHydrolocalData",
  props:['reservoirSelected', 'volumesData'],
  components: {LoadingAnimation, SaicPrecipitationData, SaicHydrologicalData},
  data(){
    return{
      currentMonthFormat: undefined,
      currentYearFormat: undefined,
      loading: false,
      showAnimation: false,
      avarageUsefulVolume: undefined,
      avarageUsefulVolumePercentage: undefined,
      accumulatedRainOfMonth: undefined,
      accumulatedOfLastThirtyDays: undefined,
      climatographicAverage: undefined,
      sourceId: 26,
    }
  },
  created(){
    this.initialize();
  },
  watch:{
    reservoirSelected(value){
      if(value){
        this.initialize();
      }
    }
  },
  computed:{
    accumulatedRainCurrentMonthSaic(){
      return this.$store.getters.accumulatedRainCurrentMonthSaic;
    },
    accumulatedRainOfTheLastThirtyDaysSaic(){
      return this.$store.getters.accumulatedRainOfTheLastThirtyDaysSaic;
    },
    climatographicAverageSaic(){
      return this.$store.getters.climatographicAverageSaic;
    },
    volumeSaic(){
      return this.$store.getters.volumeSaic;
    },
    usefulVolumePercentageSaic(){
      return this.$store.getters.usefulVolumePercentageSaic;
    }
  },
  methods:{
    loadAnimationComplete(){
      this.showAnimation = this.loading;
    },
    async initialize(){
      const currentMonthStart = moment().startOf('month');
      this.currentMonthFormat = currentMonthStart.locale("pt-br").format("MMMM");
      this.currentYearFormat = currentMonthStart.format("YYYY");
      await Promise.all([
        this.$store.dispatch('loadAccumulatedRainCurrentMonthSaic', {
          startDate: currentMonthStart.format('YYYY-MM-DD'),
          endDate: moment().format('YYYY-MM-DD'),
          locationIds: this.reservoirSelected.locationid,
        }),
        this.$store.dispatch('loadAccumulatedRainOfTheLastThirtyDaysSaic', {
          startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
          endDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
          locationIds: this.reservoirSelected.locationid,
        }),
        this.$store.dispatch('loadClimatographicAverageSaic', {
          month: moment().tz('America/Sao_Paulo').format('MM'),
          variable: 'prec',
          location_id: this.reservoirSelected.locationid,
        }),
        this.$store.dispatch('loadVolumeSaic', {
          date_start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
          date_end: moment().format('YYYY-MM-DD'),
          operation_ids: '1',
          sensor_ids: '294',
          sort: 'desc',
          station_ids: this.reservoirSelected.codigo,
        }),
        this.$store.dispatch('loadUsefulVolumePercentageSaic', {
          date_start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
          date_end: moment().format('YYYY-MM-DD'),
          operation_ids: '1',
          sensor_ids: '187',
          sort: 'desc',
          station_ids: this.reservoirSelected.codigo,
          type: 'daily',
        })
      ]);
      this.avarageUsefulVolume = this.calculateSaicVolume(this.volumeSaic);
      this.avarageUsefulVolumePercentage = this.calculateUsefulVolumePercentage(this.usefulVolumePercentageSaic);
      this.accumulatedRainOfMonth = this.calculateAccumulateRain(this.accumulatedRainCurrentMonthSaic);
      this.accumulatedOfLastThirtyDays = this.calculateAccumulateRain(this.accumulatedRainOfTheLastThirtyDaysSaic);
      this.climatographicAverage = this.calculateClimatoAverage(this.climatographicAverageSaic);
    },

    calculateSaicVolume(volumeSaic){
      const stationIds = this.reservoirSelected.codigo.split(",");
      const volumesData = [];
      for (const stationId of stationIds) {
        const volume = volumeSaic.find(item => item.estacaoId == stationId);
        if(volume) volumesData.push(volume);
      }
      if(volumesData){
        const volumeTotal = volumesData.reduce((before,current) => {
            return before + current.valor;
        },0);
        return {
          value: Number(volumeTotal).toFixed(3),
          updated: this.getMostUpdatedDate(volumesData, "data")};
      }
      return undefined;
    },

    calculateUsefulVolumePercentage(usefulVolumePercentageSaic){
      const stationIds = this.reservoirSelected.codigo.split(",");
      const percentageData = [];
      for (const stationId of stationIds) {
        const percentage = usefulVolumePercentageSaic.find(item => item.estacaoId == stationId);
        if(percentage) percentageData.push(percentage);
      }
      if(percentageData.length){
        const percentageTotal = percentageData.reduce((before,current) => {
            return before + current.valor;
        },0);
        const average = percentageTotal / percentageData.length;
        return {
          value: Number(average * 100).toFixed(1),
          updated: this.getMostUpdatedDate(percentageData, "data")};
      }
      return undefined;
    },

    getMostUpdatedDate(dataList, propertyKey){
      if(!dataList || !dataList.length) return undefined;
      const listWithdate = dataList.filter((item) => item[propertyKey]);
      return moment.max(listWithdate.map((item) => moment(item[propertyKey], "YYYY-MM-DD"))).format('DD/MM/YYYY');
    },

    calculateAccumulateRain(data){
      if(data){
        const {accumPrec, lastUpdated} = this.groupSaicRain(data);
        const updated = lastUpdated ? moment(lastUpdated).tz('America/Sao_Paulo').format('DD/MM/YYYY') : '##/##/####';
        return { value: Number(accumPrec).toFixed(1), updated: updated };
      }
      return undefined;
    },

    groupSaicRain(data){
      let accumRainSaicGroup = {};
      if(data) {
        let sum = 0;
        let updated = data[0].lastUpdated;
        for (const currentData of data) {
          if (moment(currentData.lastUpdated).isBefore(moment(currentData.lastUpdated))) {
            updated = currentData.lastUpdated;
          }

          sum += currentData.precIntensityAccum;
        }

        const average = sum / data.length;

        accumRainSaicGroup = {accumPrec: average, lastUpdated: updated};
      }

      return accumRainSaicGroup;
    },

    calculateClimatoAverage(climatographicAverageData){
      if(climatographicAverageData && climatographicAverageData.length){
        const updated = climatographicAverageData[0].updated ? moment(climatographicAverageData.updated).tz('America/Sao_Paulo').format('DD/MM/YYYY'): undefined;
        const sum = climatographicAverageData.reduce((before, current)=>{
          return before + current.value;
        }, 0);
        const average = sum / climatographicAverageData.length;
        return {value:  Number(average).toFixed(1), updated};
      }
      return undefined;
    }
  }
}
</script>
<style scoped>
.last.v-card.v-sheet.theme--dark {
  min-height: 175px;
  min-width: 352px;
  max-height: 300px;
  max-width: 1000px;
}
.default.v-card.v-sheet.theme--dark {
  min-height: 285px;
  min-width: 150px;
  max-height: 350px;
  max-width: 350px;
}

.label-text{
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #FFFFFF;
}

.data-cards {
  min-height: 280px;
}

.no-data-cards {
  min-height: 200px;
}

.unit-measurement-text{
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
}

.value-text{
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
  line-height: 47px;
}
</style>
